/**
 * Created by Ning Jiang on 2/7/2018.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {Power2, Timeline, TimelineLite, TweenLite} from "gsap";
import {BasicBitmapCountUp} from "../../display/BasicBitmapCountUp";
import {IceIceYetiGameShaker} from "../../gameshake/IceIceYetiGameShaker";
import {IceIceYetiGameAssets} from "../../IceIceYetiGameAssets";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiBigWinExplosionsController} from "./IceIceYetiBigWinExplosionsController";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {IceIceYetiParsedGameData} from "../../server/data/IceIceYetiParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";

export class IceIceYetiBigWinView extends BaseView {

    private static WAYS_TEXT_POSITION: PIXI.Point = new PIXI.Point(10, 50);
    private static WAYS_TEXT_STYLE: PIXI.TextStyle = new PIXI.TextStyle(
        {
            dropShadow: true,
            dropShadowAngle: 1.4,
            dropShadowBlur: 3,
            dropShadowDistance: 6,
            fill: [
                "#fdf451",
                "#f4b940"
            ],
            fontFamily: OpenSans.FAMILY,
            fontSize: 36,
            fontWeight: FontWeight.BOLD,
            stroke: "#ffed7a",
            strokeThickness: 1
        }
    );

    private _layer:ScalableLayer;
    private _isShowing:boolean = false;
    private _bigWinGoldExplosion:TimelineSprite;
    private _countText:BasicBitmapCountUp;
    private _countUpHasStopped:boolean;
    private _scaleContainer:PIXI.Container;
    private _dimmer:PIXI.Graphics;
    private _level01Text:TimelineSprite;
    private _level02Text:TimelineSprite;
    private _level03Text:TimelineSprite;
    private _bigWinYeti:TimelineSprite;
    private _yetiSneeze:TimelineSprite;
    private _textHit:TimelineSprite;
    private _bigWinExplosionsController:IceIceYetiBigWinExplosionsController;
    private _waysText: PIXI.Text;
    private _betWayWins: IBetWayWinData[];

    constructor() {
        super();
        this._layer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.BIG_WIN.name);
    }

    protected initAnimations():void {
        this._dimmer = new PIXI.Graphics();
        this._dimmer.alpha = 0;
        this._layer.addChild(this._dimmer);

        this._bigWinYeti = new TimelineSprite(GameResources.getTextures(IceIceYetiGameAssets.BIG_WIN_YETI));
        this._bigWinYeti.getAnimation();
        this._bigWinYeti.anchor.set(0.5, 0.5);
        this._bigWinYeti.position.x = 640;
        this._bigWinYeti.position.y = 180;
        this._bigWinYeti.show();
        this._bigWinYeti.alpha = 0;
        this.addChild(this._bigWinYeti);

        this._textHit = new TimelineSprite(GameResources.getTextures(IceIceYetiGameAssets.BIG_WIN_TEXT_HIT));
        this._textHit.anchor.set(0.5, 0.5);
        this._textHit.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._textHit.position.x = 640;
        this._textHit.position.y = 255;
        this._textHit.show();
        this._textHit.visible = false;
        this.addChild(this._textHit);

        this._level01Text = new TimelineSprite(GameResources.getTextures(IceIceYetiGameAssets.BIG_WIN_TEXT_LEVEL_01));
        this._level01Text.anchor.set(0.5, 0.5);
        this._level01Text.position.x = 640;
        this._level01Text.position.y = 280;
        this._level01Text.alpha = 0;
        this.addChild(this._level01Text);

        this._level02Text = new TimelineSprite(GameResources.getTextures(IceIceYetiGameAssets.BIG_WIN_TEXT_LEVEL_02));
        this._level02Text.anchor.set(0.5, 0.5);
        this._level02Text.position.x = 640;
        this._level02Text.position.y = 280;
        this._level02Text.alpha = 0;
        this.addChild(this._level02Text);

        this._level03Text = new TimelineSprite(GameResources.getTextures(IceIceYetiGameAssets.BIG_WIN_TEXT_LEVEL_03));
        this._level03Text.anchor.set(0.5, 0.5);
        this._level03Text.position.x = 640;
        this._level03Text.position.y = 280;
        this._level03Text.alpha = 0;
        this.addChild(this._level03Text);

        this._yetiSneeze = new TimelineSprite(GameResources.getTextures(IceIceYetiGameAssets.YETI_SNEEZE));
        this._yetiSneeze.anchor.set(0.5, 0.5);
        this._yetiSneeze.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._yetiSneeze.position.x = 636;
        this._yetiSneeze.position.y = 206;
        this._yetiSneeze.show();
        this._yetiSneeze.visible = false;
        this.addChild(this._yetiSneeze);

        this._bigWinGoldExplosion = new TimelineSprite(GameResources.getTextures(IceIceYetiGameAssets.BIG_WIN_EXPLOSION));
        this._bigWinGoldExplosion.anchor.set(0.5, 0.5);
        this._bigWinGoldExplosion.position.x = 640;
        this._bigWinGoldExplosion.position.y = 340;
        this._bigWinGoldExplosion.hide();
        this.addChild(this._bigWinGoldExplosion);

        this._scaleContainer = new PIXI.Container();
        this._scaleContainer.position.set(640, 460);
        this._scaleContainer.alpha = 0;
        this._countText = new BasicBitmapCountUp(IceIceYetiGameConfig.TEXT_STYLES.WIN_COUNTUP_NUMBERS_TEXT_STYLE, 620);
        this._scaleContainer.addChild(this._countText);
        this.addChild(this._scaleContainer);

        this._waysText = new PIXI.Text("", IceIceYetiBigWinView.WAYS_TEXT_STYLE);
        this._waysText.anchor.set(0.5, 0.5);
        this._waysText.position = IceIceYetiBigWinView.WAYS_TEXT_POSITION;
        this._waysText.visible = false;
        this._scaleContainer.addChild(this._waysText);

        this._layer.addChild(this);

        this._bigWinExplosionsController = new IceIceYetiBigWinExplosionsController();
        this._bigWinExplosionsController.createAnimations();
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:IceIceYetiParsedGameData):void {
        this._betWayWins = <IBetWayWinData[]><unknown>data.betWins;
    }

    private calculateTotalWinWays():number{
        let totalBeyWays:number = 0;
        for (let i:number=0;i<this._betWayWins.length;i++){
            totalBeyWays += this._betWayWins[i].numberOfCombinations;
        }
        return totalBeyWays;
    }

    protected onResize(resizeData:IResizeData):void {
        if(!this._isShowing) {
            this._isResizeDirty = true;
            return;
        }

        this._isResizeDirty = false;
        const screenWidth:number = Math.ceil(resizeData.width / this._layer.scale.x);
        const screenHeight:number = Math.ceil(resizeData.height / this._layer.scale.y);
        const leftOffset:number = Math.floor(-this._layer.x / this._layer.scale.x);
        const topOffset:number = Math.floor(-this._layer.y / this._layer.scale.y);


        this._dimmer.clear();
        this._dimmer.beginFill(0x321e43, 0.6);
        this._dimmer.drawRect(leftOffset, topOffset, screenWidth, screenHeight);
    }

    public playCountUp(from:number, to:number, duration:number):Timeline | null {
        this._countUpHasStopped = false;
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            new TweenLite(this._scaleContainer, 0.4, {alpha : 1}),
            this._countText.getCountAnimation(from, to, duration)
        ]);
        return timeline;
    }

    private checkShowWaysWin():void {
        if (SlotGame.api.gameClientConfiguration.displayIndividualWinsInGame == true && this._waysText.visible == false){
            let totalWinWays:number = this.calculateTotalWinWays();
            const waysText: string = (totalWinWays == 1 ? "Way Won" : "Ways Won");
            this._waysText.text = totalWinWays + " " + Translation.translate(waysText);
            this._waysText.visible = true;
        }
    }

    public getBigWinLevelAnimation(winRatioConfig:IWinRatioConfig):Timeline {
        this._isShowing = true;
        if(this._isResizeDirty) {
            this.onResize(this._resizeData);
        }
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(()=>{
            this.checkShowWaysWin();
        });
        timeline.add([
            () => {
                this.updateBigWinLevelAnimation(winRatioConfig.text!);
            },
            TweenLite.to(this._dimmer, 0.1, {alpha : 1}),
            this.getWinTextTimeline(winRatioConfig.type!),
            new TweenLite(this._bigWinYeti, 0.2, {alpha : 1}),
            this.playYetiSneezeAnimation(winRatioConfig.type!),
            new TweenLite(this._bigWinYeti.scale, winRatioConfig.duration, {x : 1})
        ]);

        return timeline;
    }

    private playYetiSneezeAnimation(winType:WinRatioType):TimelineLite {
        const sneezeTimeline:TimelineLite = new TimelineLite();
        if(winType == WinRatioType.BIG_WIN) {
            // Blink after 1 and 3 sec
            sneezeTimeline.add([
                () => (this._bigWinExplosionsController.playExplosions(winType)),
                () => this._scaleContainer.scale.set(this.getWinTypeScale(winType), this.getWinTypeScale(winType)),
                this._bigWinGoldExplosion.getAnimationAutoShowHide(),
                this.getScreenShakeAnimation
            ]);
            sneezeTimeline.add(this._bigWinYeti.getAnimation([60]), "=+" + MathHelper.randomNumberInRange(0.5, 1.5, 1));
            sneezeTimeline.add(this._bigWinYeti.getAnimation([60]), "=+" + MathHelper.randomNumberInRange(0.5, 1.5, 1));
        } else {
            sneezeTimeline.add(this._bigWinYeti.getAnimation([0, 31]));
            sneezeTimeline.add(() => this._yetiSneeze.visible = true);
            sneezeTimeline.add([
                this._yetiSneeze.getAnimation(),
                this.getScreenShakeAnimation,
                this._bigWinYeti.getAnimation([32]),
                new TweenLite(this._scaleContainer.scale, 0.3, {
                    x : this.getWinTypeScale(winType),
                    y : this.getWinTypeScale(winType),
                    ease : Power2.easeOut
                }),
                this._bigWinGoldExplosion.getAnimationAutoShowHide(),
                () => (this._bigWinExplosionsController.playExplosions(winType))
            ]);
            sneezeTimeline.add(() => this._yetiSneeze.visible = false);
        }

        return sneezeTimeline;
    }

    private getScreenShakeAnimation():TimelineLite {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiGameShaker.START_GAME_SHAKING)), "-=0.1");
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(IceIceYetiGameShaker.STOP_GAME_SHAKING)), "+=0.9");
        return timeline;
    }

    private updateBigWinLevelAnimation(text:string):void {
        this._isShowing = true;
    }

    private stopCountAt(to:number, winType:WinRatioType):void {
        if(!this._countUpHasStopped) {
            this._countUpHasStopped = true;
        }
        //this.playCountUpEndSound();
        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => this._countText.stopAt(to),
            new TweenLite(this._scaleContainer.scale, 0.1, {
                    x : this.getWinTypeScale(winType) + (this.getWinTypeScale(winType) * 0.1),
                    y : this.getWinTypeScale(winType) + (this.getWinTypeScale(winType) * 0.1),
                    ease : Power2.easeOut
                }
            )]);
        timeline.add(new TweenLite(this._scaleContainer.scale, 0.2, {
            x : this.getWinTypeScale(winType),
            y : this.getWinTypeScale(winType),
            ease : Power2.easeOut
        }));
    }

    public playEndingAnimation(endWinRatioConfig:IWinRatioConfig, isAborted:boolean, totalWin:number):void {
        this._bigWinExplosionsController.abortExplosions();
        const timeline:TimelineLite = new TimelineLite();
        if(isAborted == true) {
            this.checkShowWaysWin();
            this._yetiSneeze.visible = false;
            this._textHit.visible = false;
            this._bigWinYeti.alpha = 1;
            this._bigWinYeti.getAnimation([0, 0]);
            this._bigWinGoldExplosion.getAnimationAutoShowHide(true, true, [0]);
            this.stopCountAt(totalWin, endWinRatioConfig.type!);
            this.getScreenShakeAnimation();
            TweenLite.to(this._scaleContainer, 0.1, {alpha : 1});
            timeline.add(this.getAbortWinTextTimeline(endWinRatioConfig.type!));
        }
        timeline.add(TweenLite.to(this._dimmer, 0.1, {alpha : 0}));
        timeline.add(() => this._countText.stopAt(totalWin));
        timeline.add([
            () => this.updateBigWinLevelAnimation(endWinRatioConfig.text!),
            TweenLite.fromTo(this.getWinTypeText(endWinRatioConfig.type!), 0.2, {alpha : 1}, {alpha : 0}),
            new TweenLite(this._scaleContainer, 0.6, {alpha : 0}),
            new TweenLite(this._bigWinYeti, 0.6, {alpha : 0})
        ], "+=1.2");
        timeline.add(() => {
            this._waysText.visible = false;
            this._isShowing = false
        });

        timeline.play();
    }

    private getAbortWinTextTimeline(winType:WinRatioType):TimelineLite {
        const winTextTimeline:TimelineLite = new TimelineLite();
        const winText:TimelineSprite = this.getWinTypeText(winType);
        this._level01Text.alpha = 0;
        this._level02Text.alpha = 0;
        this._level03Text.alpha = 0;

        winTextTimeline.add(() => winText.alpha = 1);
        if(winType == WinRatioType.BIG_WIN) {
            winTextTimeline.add(() => winText.getAnimation([0, 0]));
        } else {
            winTextTimeline.add(winText.getAnimation([5, 5]));
        }
        return winTextTimeline;
    }

    private getWinTextTimeline(winType:WinRatioType):TimelineLite {
        const winTextTimeline:TimelineLite = new TimelineLite();
        const winText:TimelineSprite = this.getWinTypeText(winType);
        if(winType == WinRatioType.BIG_WIN) {
            winTextTimeline.add(() => winText.getAnimation([0, 0]));
            winTextTimeline.add(new TweenLite(winText, 0.2, {alpha : 1}));
            return winTextTimeline;
        } else if(winType == WinRatioType.MEGA_WIN) {
            winTextTimeline.add(this.getWinTypeText(WinRatioType.BIG_WIN).getAnimation([0]), "+=0.2");
            winTextTimeline.add(() => this.getWinTypeText(WinRatioType.BIG_WIN).alpha = 0);
            winTextTimeline.add(() => winText.alpha = 1);
            winTextTimeline.add(winText.getAnimation([0, 15]));
            winTextTimeline.add(() => this._textHit.visible = true);
            winTextTimeline.add(this._textHit.getAnimation([0]));
            winTextTimeline.add(() => this._textHit.visible = false);
        } else {
            winTextTimeline.add(this.getWinTypeText(WinRatioType.MEGA_WIN).getAnimation([16]));
            winTextTimeline.add(() => this.getWinTypeText(WinRatioType.MEGA_WIN).alpha = 0);
            winTextTimeline.add(() => winText.alpha = 1);
            winTextTimeline.add(winText.getAnimation([0, 15]));
            winTextTimeline.add(() => this._textHit.visible = true);
            winTextTimeline.add([
                this._textHit.getAnimation([0]),
                winText.getAnimation([16])
            ]);
            winTextTimeline.add(() => this._textHit.visible = false);

        }
        return winTextTimeline;
    }

    private getWinTypeText(winType:WinRatioType):TimelineSprite {
        switch(winType) {
            case WinRatioType.SUPER_MEGA_WIN :
                return this._level03Text;

            case WinRatioType.MEGA_WIN :
                return this._level02Text;

            case WinRatioType.BIG_WIN :
                return this._level01Text;

            default :
                return this._level01Text;
        }
    }

    private getWinTypeScale(winType:WinRatioType):number {
        switch(winType) {
            case WinRatioType.SUPER_MEGA_WIN :
                return 0.9;

            case WinRatioType.MEGA_WIN :
                return 0.8;

            case WinRatioType.BIG_WIN :
                return 0.7;

            default :
                return 0.7;
        }
    }

    public preCalculateCountScale(totalWin:number) {
        this._countText.preCalculateScale(0, totalWin);
    }
}